import { AuthPermIdentifier, AuthPermIdentifierParent } from "../auth-perm-identifier";
import { RequestBase, RequestBaseSet } from "./request-base";
import { ResponseBase, ResponseBaseSet } from "./response-base";


export class RequestUserPermission extends RequestBase {

  route?: string | null;
  parentId?: string | null;
  code?: string | null;
  propertyPermissions?: boolean | null;
  userFilterId?: string | null;
  authTypes?: string[] | null;
  hierarchyIds?: string[] | null;
  hierarchyCodes?: string[] | null;
  includeExclusions?: boolean | null;
}


export class ResponseUserPermission extends ResponseBaseSet<AuthPermIdentifier> {

}

export class ResponseUserPermissionParent extends ResponseBaseSet<AuthPermIdentifierParent> {

}

export class RequestUserPermissionSet extends RequestBaseSet<AuthPermIdentifier>{

  userIds?: string[] | null;
  licenseId?: string | null;

  updateRoles?: boolean | null;
  updatePerms?: boolean | null;

  roleIds?: string[] | null;

  authTypes?: string[] | null;
  hierarchyIds?: string[] | null;

}

export class ResponseUserPermissionSet extends ResponseBase {

}
